module.exports = __webpack_public_path__ + "cf7515f457c9d745303d122a7c94e6cb.svg";